export const AppConfig = {
  BASE_API_URL: process.env.REACT_APP_BASE_API_URL,
  API_URL: `${process.env.REACT_APP_BASE_API_URL}/v1/admins`,
};
